import { lazyImportSvg } from '@/shared/utils/lazy/lazy-import-svg';

export const AlertPopupIcons = {
  Approve: lazyImportSvg(() => import('@/assets/icons/alert-popup/approve.svg')),
  ListWithX: lazyImportSvg(() => import('@/assets/icons/alert-popup/list-with-x.svg')),
  Reject: lazyImportSvg(() => import('@/assets/icons/alert-popup/reject.svg')),
};

export default AlertPopupIcons;
